import Vue from 'vue'
import moment from 'moment'

Vue.filter('formateTime', (value) => {
  //YYYY-MM-DD HH:mm:ss
  return moment(value * 1000).format('YYYY-MM-DD')
})

Vue.filter('formatDuration', (time) => {
  //满分钟显示分钟 满小时显示小时 满天显示天

  let duration = moment.duration(time, 'seconds')
  let formatStr = []
  if (duration.years()) {
    formatStr.push(`${duration.years()}年`)
  }
  if (duration.months()) {
    formatStr.push(`${duration.months()}月`)
  }
  if (duration.days()) {
    formatStr.push(`${duration.days()}日`)
  }
  if (duration.hours()) {
    formatStr.push(`${duration.hours()}小时`)
  }
  if (duration.minutes()) {
    formatStr.push(`${duration.minutes()}分钟`)
  }

  if (duration.seconds()) {
    formatStr.push(`${duration.seconds()}秒`)
  }

  return formatStr.slice(0, 2).join(' ')
  // return moment.duration(time, 'seconds').humanize(true)
})


Vue.filter('stringCut', (str,length) => {

  if(str != null && str != undefined){

    if(str.length > length){
      return str.slice(0,length) +'...'
    }
  }
  return str
})


Vue.filter('numberFormat', (str,length) => {

  if(str != null && str != undefined){
    str = str + ""
    if(str.length > length){
      str = str.slice(0,str.length-length)
      if(length == 3){
        str = str + "千"
      }else if (length == 4) {
        str = str + "万"
      }
    }
  }
  return str
})



